import { getDecisionNodeAtPath } from 'extractFromState';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ProcessingSpinnerWrapper } from './DTProcessingNode.styles';
import { DECISION_NODE_PROCESSING_FUNCTIONS } from 'actions/tools/DecisionTree/ProcessingFunctionMap';
import { isFunction } from 'lodash';
import { returnToPreviousMacroWizardPath } from 'actions/searchActions';
import { handleError } from 'services/ErrorService/ErrorService';
import Loading from '../../../LoadingComponent/LoadingComponent';

const DTProcessingNode = () => {
  const dispatch = useDispatch();
  const decisionNode = useSelector(getDecisionNodeAtPath);

  useEffect(() => {
    const processing = decisionNode?.processing;
    try {
      const processingFunction = DECISION_NODE_PROCESSING_FUNCTIONS[processing];
      if (isFunction(processingFunction)) {
        dispatch(processingFunction());
      } else {
        handleError({ customMessage: 'The processing function does not exist.', popupOnly: true });
      }
    } catch (error) {
      dispatch(returnToPreviousMacroWizardPath());
      handleError({
        error,
        customMessage: `There was an error when processing the order for ${processing}.`,
        showPopup: true,
      });
    }
  }, [dispatch, decisionNode]);

  return (
    <ProcessingSpinnerWrapper>
      <Loading label="Processing" />
    </ProcessingSpinnerWrapper>
  );
};

export default DTProcessingNode;
